module.exports = __webpack_public_path__ + "static/media/sp.9cdd1b84.jpg";